import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.69412,0 1920,430.305882 1920,960 C1920,1489.69412 1489.69412,1920 960,1920 C430.305882,1920 0,1489.69412 0,960 C0,787.2 46.3058824,617.788235 134.4,470.964706 L134.4,470.964706 L169.411765,412.235294 L198.776471,438.211765 L633.6,873.035294 C625.694118,900.141176 621.176471,929.505882 621.176471,960 C621.176471,1146.35294 773.647059,1298.82353 960,1298.82353 C1146.35294,1298.82353 1298.82353,1146.35294 1298.82353,960 C1298.82353,773.647059 1146.35294,621.176471 960,621.176471 C940.8,621.176471 921.6,623.435294 903.529412,626.823529 L903.529412,626.823529 L903.529412,0 Z M322.334118,242.371765 L845.929412,766.08 C879.585882,746.315294 918.211765,734.117647 960,734.117647 C1084.57412,734.117647 1185.88235,835.425882 1185.88235,960 C1185.88235,1084.57412 1084.57412,1185.88235 960,1185.88235 C835.425882,1185.88235 734.117647,1084.57412 734.117647,960 C734.117647,918.211765 746.315294,879.585882 766.08,845.929412 L766.08,845.929412 L242.371765,322.334118 L322.334118,242.371765 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTimerSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTimerSolid, _Component);

  var _super = _createSuper(IconTimerSolid);

  function IconTimerSolid() {
    _classCallCheck(this, IconTimerSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTimerSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTimer",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTimerSolid.displayName = "IconTimerSolid";
  return IconTimerSolid;
}(Component);

IconTimerSolid.glyphName = 'timer';
IconTimerSolid.variant = 'Solid';
IconTimerSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTimerSolid;
export { IconTimerSolid };